document.addEventListener('DOMContentLoaded', function () {
  const STORAGE_KEY = 'cmPopupLastShownDate';

  // YYYY-MM-DD（ローカル時間）
  const getTodayStr = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  };
  const todayStr = getTodayStr();

  //本日をセット
  const saveShownToday = () => {
    try {
      localStorage.setItem(STORAGE_KEY, todayStr);
    } catch (e) {}
  };

  //最終アクセスをゲット
  let lastShownDate = null;
  try {
    lastShownDate = localStorage.getItem(STORAGE_KEY);
  } catch (e) {}

  //モーダルを初期化
  MicroModal.init({
    // disableScroll: true,
    // disableFocus: true,
  });

  //最終アクセスが本日でない場合はモーダルを表示可能に
  const cmPopup = document.getElementById('cm-popup');
  const shouldShow = cmPopup && lastShownDate !== todayStr;
  //テスト用
  //const shouldShow = true;

  // ★ モーダル内リンククリックでも「今日」を保存して遷移先で開かないようにする
  if (cmPopup) {
    cmPopup.addEventListener('click', (e) => {
      const a = e.target.closest('a');
      if (!a) return;

      // hash だけのリンク（#close とか）は必要に応じて除外したければここで分岐
      // if (a.getAttribute('href')?.startsWith('#')) return;

      saveShownToday();

      // 後始末を確実に走らせたいなら閉じる（onCloseが動く）
      try {
        MicroModal.close('cm-popup');
      } catch (e2) {}
      // ※このあと通常どおり遷移するので preventDefault は不要
    });
  }

  //モーダル表示
  if (shouldShow) {
    MicroModal.show('cm-popup', {
      onShow: (modal) => {
        document.body.style.overflow = 'hidden';

        const main = modal.querySelector('.modal__main');
        if (main) main.scrollTop = 0;

        const closeBtn = modal.querySelector('.modal__close');
        //if (closeBtn) closeBtn.focus();
      },
      onClose: (modal) => {
        document.body.style.overflow = '';

        // 閉じた「今日」を保存
        try {
          localStorage.setItem(STORAGE_KEY, todayStr);
        } catch (e) {}
      },
    });
  }

  //カウントダウン
  const countdown = document.querySelector('.countdown');
  if (countdown) {
    document
      .querySelectorAll('.countdown[data-target][data-tz]')
      .forEach((el) => {
        const targetStr = (el.getAttribute('data-target') || '').trim(); // "YYYY-MM-DD HH:mm:ss"
        const tz = (el.getAttribute('data-tz') || '+09:00').trim(); // "+09:00"

        const isoLike = targetStr.replace(' ', 'T') + tz;
        const target = new Date(isoLike);

        // ===== 不正日付チェック =====
        const [datePart] = targetStr.split(' ');
        const [y, m, d] = (datePart || '').split('-').map(Number);

        if (
          Number.isNaN(target.getTime()) || // Dateとして不正
          target.getFullYear() !== y || // 年がズレてる
          target.getMonth() + 1 !== m || // 月がズレてる
          target.getDate() !== d // 日がズレてる（← 2/31対策）
        ) {
          el.style.display = 'none';
          console.log('カウントダウンで設定された日付が正しくありません');
          return;
        }

        const dEl = el.querySelector('[data-days]');
        const hEl = el.querySelector('[data-hours]');
        const mEl = el.querySelector('[data-minutes]');
        const sEl = el.querySelector('[data-seconds]');

        const pad2 = (n) => String(n).padStart(2, '0');

        const update = () => {
          const now = new Date();
          const diffMs = target.getTime() - now.getTime();

          if (diffMs <= 0) {
            el.style.display = 'none'; // ✅ 終了したら非表示
            //MicroModal.close('cm-popup');
            const heading = document.querySelector('.modal__heading');
            const finHeading = document.querySelector('.modal__fin-heading');
            if (finHeading && finHeading.textContent.trim() !== '') {
              finHeading.style.display = 'block';
              if (heading) heading.style.display = 'none';
            }
            clearInterval(timer);
            return;
          }

          const total = Math.floor(diffMs / 1000);
          const days = Math.floor(total / 86400);
          const hours = Math.floor((total % 86400) / 3600);
          const minutes = Math.floor((total % 3600) / 60);
          const seconds = total % 60;

          dEl.textContent = pad2(days);
          hEl.textContent = pad2(hours);
          mEl.textContent = pad2(minutes);
          sEl.textContent = pad2(seconds);
        };

        update();
        const timer = setInterval(update, 1000);
      });
  }
});
